var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-link',{attrs:{"to":_vm.$pagePath('offers')}},[_c('vs-button',_vm._b({attrs:{"size":"large","type":"primary"}},'vs-button',_vm.$attrs,false),[_vm._v("\n    "+_vm._s(_vm.$t('allOffers'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }